import { render, staticRenderFns } from "./ShippingMethodList.vue?vue&type=template&id=4a45082a&"
import script from "./ShippingMethodList.vue?vue&type=script&lang=js&"
export * from "./ShippingMethodList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports